import { AppTheme } from '../types';

export const defaultTheme: AppTheme = {
  colors: {
    primary: '#0f172a', // slate-900
    secondary: '#1e293b', // slate-800
    accent: '#0891b2', // cyan-600
    background: '#020617', // slate-950
    surface: '#334155', // slate-700
    text: {
      primary: '#f8fafc', // slate-50
      secondary: '#94a3b8', // slate-400
      accent: '#06b6d4' // cyan-500
    }
  },
  spacing: {
    xs: '0.25rem', // 4px
    sm: '0.5rem',  // 8px
    md: '1rem',    // 16px
    lg: '1.5rem',  // 24px
    xl: '2rem'     // 32px
  },
  borderRadius: {
    sm: '0.25rem', // 4px
    md: '0.5rem',  // 8px
    lg: '0.75rem', // 12px
    xl: '1rem'     // 16px
  }
};

// CSS classes mapping for Tailwind
export const themeClasses = {
  backgrounds: {
    primary: 'bg-slate-900',
    secondary: 'bg-slate-800',
    accent: 'bg-cyan-600',
    surface: 'bg-slate-700',
    dark: 'bg-slate-950'
  },
  text: {
    primary: 'text-slate-50',
    secondary: 'text-slate-400',
    accent: 'text-cyan-500',
    white: 'text-white'
  },
  borders: {
    default: 'border-slate-700',
    accent: 'border-cyan-500'
  },
  gradients: {
    primary: 'bg-gradient-to-r from-slate-900 to-slate-800',
    accent: 'bg-gradient-to-r from-cyan-600 to-blue-600'
  },
  shadows: {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl'
  },
  spacing: {
    section: 'py-20',
    container: 'container mx-auto px-6',
    grid: 'grid gap-8',
    gridCols: {
      sm: 'md:grid-cols-2',
      md: 'md:grid-cols-3',
      lg: 'md:grid-cols-2 lg:grid-cols-4'
    }
  },
  typography: {
    h1: 'text-4xl md:text-6xl font-bold',
    h2: 'text-4xl font-bold',
    h3: 'text-xl font-semibold',
    body: 'text-lg',
    subtitle: 'text-xl'
  },
  components: {
    card: 'bg-slate-800 p-6 rounded-xl border border-slate-700',
    buttons: {
      primary: 'px-6 py-2.5 bg-gradient-to-r from-teal-400 to-sky-500 text-white font-semibold rounded-lg shadow-lg transition-all duration-300 hover:from-teal-500 hover:to-sky-600 hover:shadow-xl',
      secondary: 'px-5 py-2 text-gray-400 font-semibold rounded-lg border border-slate-700 hover:border-teal-400 transition-colors duration-200',
      outline: 'px-5 py-2 border border-slate-700 text-slate-300 hover:border-teal-400 hover:text-teal-400 rounded-lg transition-colors duration-200',
      ghost: 'px-4 py-2 text-slate-300 hover:text-teal-400 transition-colors duration-200'
    },
    button: {
      primary: 'px-6 py-2.5 bg-gradient-to-r from-teal-400 to-sky-500 text-white font-semibold rounded-lg shadow-lg transition-all duration-300 hover:from-teal-500 hover:to-sky-600 hover:shadow-xl',
      secondary: 'px-5 py-2 text-gray-400 font-semibold rounded-lg border border-slate-700 hover:border-teal-400 transition-colors duration-200'
    },
    input: 'w-full p-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:border-cyan-500 focus:outline-none',
    select: 'w-full p-3 bg-slate-700 border border-slate-600 rounded-lg text-white focus:border-cyan-500 focus:outline-none',
    textarea: 'w-full p-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:border-cyan-500 focus:outline-none resize-none'
  }
};

// Animation classes
export const animations = {
  fadeIn: 'animate-fade-in',
  slideUp: 'animate-slide-up',
  bounce: 'animate-bounce',
  pulse: 'animate-pulse',
  spin: 'animate-spin'
};

// Responsive breakpoints
export const breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px'
};